module.exports = __webpack_public_path__ + "assets/98b06758a7c348527861d930a2f66314.png";